export default __webpack_public_path__ + "static/media/ScreenedReport.514705a9.svg";